import React from "react";
import TimeTablePageSection from "../../Sections/TimeTablePageSection/Content";
const TimeTablePage = () => {
  return <TimeTablePageSection />;
};

export default TimeTablePage;
